var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c("div", { staticClass: "row no-gutters mx-0" }, [
        _c("div", { staticClass: "col" }, [
          _vm.pageData.Error && this.pageData.fields !== null
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _c(
                  "div",
                  { staticClass: "my-0 w-100", attrs: { role: "alert" } },
                  [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col d-inline-block my-auto payment-error p-0",
                          attrs: { "aria-level": "3" }
                        },
                        [
                          _c("strong", [_vm._v("Payment Error: ")]),
                          _vm._v(
                            _vm._s(_vm.pageData.Error.Message) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.pageData.fields === null
            ? _c(
                "div",
                { staticClass: "row px-4", attrs: { id: "errorMsg" } },
                [_vm._m(1)]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters" }, [
            _vm.carrierFinalRateSection &&
            _vm.carrierFinalRateSection.premium_amount
              ? _c(
                  "div",
                  {
                    staticClass: "col-12",
                    class: { "mx-auto": _vm.finalDriversIncidents.length === 0 }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md-6 pr-4" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "border-green rounded-bottom border-thick"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "carrier-logo mx-auto text-center mt-2 mb-0"
                              },
                              [
                                _c("img", {
                                  staticStyle: { "max-width": "8rem" },
                                  attrs: {
                                    src: this.carrierFinalRateSection.logo_path
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "final-rate mx-auto text-center text-primary font-weight-bold"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("currency-filter")(
                                        this.carrierFinalRateSection
                                          .premium_amount
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-center smaller-font-content text-gray"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    this.carrierFinalRateSection.policy_term
                                  ) + "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-center smaller-font-content text-danger-checkout my-2 mx-4"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(this.carrierFinalRateSection.blurb) +
                                    "\n                "
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6 px-4" }, [
                        _c(
                          "h3",
                          { staticClass: "text-center text-gray py-2" },
                          [_vm._v("Original Quoted Rate")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "quote text-center text-gray font-weight-bold"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency-filter")(
                                  this.carrierFinalRateSection
                                    .original_premium_amount
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-center smaller-font-content text-gray"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                this.carrierFinalRateSection
                                  .original_policy_term
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "quote-adjust smaller-font-content text-gray mt-3",
                          domProps: {
                            innerHTML: _vm._s(
                              this.carrierFinalRateSection
                                .premium_adjustment_reason
                            )
                          }
                        })
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.finalDriversIncidents && _vm.finalDriversIncidents.length > 0
              ? _c("div", { staticClass: "col-12 mt-4" }, [
                  _c("div", { staticClass: "shadow-sm" }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-table",
                        attrs: { id: "driver-incidents-collapse-click" },
                        on: {
                          click: function($event) {
                            return _vm.driverIncidentsCloseOpen()
                          }
                        }
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-table-cell w-100 pl-3 py-2 text-dark-gray bg-driver-inc smaller-font-content font-weight-bold"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-inline-block",
                                attrs: { role: "alert", "aria-atomic": "true" }
                              },
                              [_vm._v("Driver Incidents")]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              ref: "driverIncidentsCollapseRef",
                              staticClass:
                                "d-inline-block float-right mr-3 plusminus active"
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "driverIncidentsContent",
                        staticClass: "pb-2",
                        staticStyle: { display: "block" }
                      },
                      [
                        _c("div", { staticClass: "row mx-0 mt-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-9 d-inline-block smaller-font-content text-gray"
                            },
                            [
                              _vm._v(
                                "\n                  The following consumer information was returned by the consumer reporting agency. When updating your\n                  premium, we only use the reported items that are compliant with the insurance laws and regulations\n                  in your state.\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-md-3" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-primary-checkout d-inline-block center",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.openBreakdownModal(
                                      "reporting-agency-modal"
                                    )
                                  }
                                }
                              },
                              [_vm._v("Reporting Agency")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "modal",
                          {
                            attrs: {
                              name: "reporting-agency-modal",
                              height: "auto",
                              scrollable: true
                            },
                            on: {
                              opened: function($event) {
                                return _vm.modalOpened("reportAgency")
                              }
                            }
                          },
                          [
                            _c("Trap", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "breakdown-modal-top pt-2 pl-3 pr-2 bg-primary text-white"
                                },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "breakdown-modal-header" },
                                    [
                                      _vm._v(
                                        "Consumer Reporting Agency Information"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      ref: "reportAgency",
                                      staticClass:
                                        "cursorBox fa-stack uniform-icon-breakdown",
                                      attrs: {
                                        href: "JavaScript:void(0);",
                                        id: "reportAgency",
                                        name: "reportAgency"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.closeBreakdownModal(
                                            "reporting-agency-modal"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "fas fa-circle fa-stack-2x",
                                        staticStyle: { color: "#fff" }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "fas fa-times fa-stack-1x",
                                        staticStyle: { color: "#1C3664" }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "mt-3 px-3",
                                  attrs: { id: "reporting-agency-content" }
                                },
                                [
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        "Why Your Premium Has Been Updated"
                                      )
                                    ]),
                                    _c("br"),
                                    _vm._v(
                                      "Initially, your premium was based upon\n                      the information you provided to us when you first received your quote. As part of our\n                      verification process, we order driving records and claims history reports from a consumer\n                      reporting agency - this is normal in the insurance industry."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("strong", [_vm._v("LexisNexis")]),
                                    _c("br"),
                                    _vm._v(
                                      "LexisNexis is an information provider, and is not responsible\n                      for the insurance company's decision to change your premium. They will not be able to provide\n                      specific reasons for the insurance company's decision."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v("How to Contact LexisNexis")
                                    ]),
                                    _c("br"),
                                    _vm._v(
                                      "If you have questions concerning the information\n                      in your consumer reports please contact LexisNexis directly. You can get a free copy of your\n                      report by contacting LexisNexis within 60 days."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-center font-weight-bold text-primary",
                                      attrs: {
                                        id: "consumer-disclosure-para-holder"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      1-800-456-6004"
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "d-block",
                                          attrs: {
                                            id: "consumer-disclosure-anchor",
                                            href:
                                              "https://www.consumerdisclosure.com/",
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("consumerdisclosure.com")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _vm._l(_vm.finalDriversIncidents, function(
                              item,
                              key
                            ) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: key + "2",
                                    staticClass:
                                      "row mx-3 py-1 smaller-font-content incident-item"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col border-right font-weight-bold"
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2 border-right" },
                                      [_vm._v(_vm._s(item.type))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2 border-right" },
                                      [_vm._v(_vm._s(item.date))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col" }, [
                                      _vm._v(_vm._s(item.description))
                                    ])
                                  ]
                                )
                              ]
                            }),
                            _vm._v(" "),
                            _vm.finalDriversIncidents &&
                            _vm.finalDriversIncidents.length == 0
                              ? [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "mt-2 text-center font-weight-bold",
                                      attrs: { id: "no-incidents-msg" }
                                    },
                                    [_vm._v("No incidents were found.")]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.paymentPlanFields && _vm.paymentPlanFields.length > 0
              ? _c("div", { staticClass: "col-12 pt-4" }, [
                  _c(
                    "div",
                    { staticClass: "shadow-sm" },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            {
                              staticClass: "p-1",
                              attrs: { "header-tag": "header", role: "tab" }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.PaymentOptions",
                                      modifiers: { PaymentOptions: true }
                                    }
                                  ],
                                  attrs: { block: "", variant: "primary" }
                                },
                                [
                                  _c("span", { staticClass: "card-heading" }, [
                                    _c("span", {
                                      staticClass: "fas fa-car mr-1"
                                    }),
                                    _vm._v(
                                      "\n                    Payment Options\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "toggle-icon",
                                      attrs: { "data-v-87cda704": "" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "toggle-down fas fa-b-angle-down",
                                        attrs: { "data-v-87cda704": "" }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "toggle-up fas fa-b-angle-up",
                                        attrs: { "data-v-87cda704": "" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "PaymentOptions",
                                visible: "",
                                accordion: "paymentOptions",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _c("b-card-text", [
                                    true
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row mt-2 no-gutters smaller-font-content expandPanel show"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "QTE_BillPlan"
                                                    ),
                                                    expression:
                                                      "errors.has('QTE_BillPlan')"
                                                  }
                                                ],
                                                staticClass:
                                                  "row mx-0 mt-2 no-gutters"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 d-inline-block"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "small mt-3 mb-1 p-2 form-error"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _c("strong", [
                                                            _vm._v("Required:")
                                                          ]),
                                                          _vm._v(
                                                            " Please select a payment option."
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row mx-0 mt-2 no-gutters"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 d-inline-block text-faint-gray"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "star" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _vm._v(
                                                      "If the customer is ready to buy, proceed with the following\n                          payment options. "
                                                    ),
                                                    _vm.checkoutPageName ===
                                                    "progCheckout"
                                                      ? [
                                                          _vm._v(
                                                            '"Pay by Mail"\n                            options require a one-time payment due today, and future paper bills are received by\n                            mail.'
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.checkoutPageName ===
                                                    "safeCheckout"
                                                      ? [
                                                          _vm._v(
                                                            '"By Mail" options require a one-time\n                            payment due today, and future paper bills are received by mail.'
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.checkoutPageName ===
                                                    "progCheckout"
                                                      ? [
                                                          _c("br"),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("strong", [
                                                            _vm._v(
                                                              "Installment Fee Disclosure"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                            (Interest charges/Service charges/Installment fees) vary based on how you choose to pay.\n                            The recurring checking account option (also known as EFT) offers lower monthly (interest\n                            charges/service charges/installment fees) than our other installment payment plans. Or you\n                            can avoid these fees altogether by paying for each policy period in full.\n                          "
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.checkoutPageName ===
                                                    "nwidCheckout"
                                                      ? [
                                                          _vm._v(
                                                            '"Monthly Direct" options require a\n                            one-time payment due today, and future payments are submitted through your Nationwide\n                            online account.'
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.paymentPlanFields,
                                              function(item, key) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: key,
                                                    staticClass: "w-100"
                                                  },
                                                  [
                                                    _vm.newHeader(
                                                      key,
                                                      _vm.paymentPlanFields,
                                                      item.sub_section
                                                    )
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row mt-2 py-1 bg-gray text-dark-gray no-gutters"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-12 px-3",
                                                                  attrs: {
                                                                    role:
                                                                      "heading",
                                                                    "aria-level":
                                                                      "4"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.sub_section
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row py-1 smaller-font-content font-weight-bold bg-light text-center text-dark-gray no-gutters"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col border-right px-3"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Payment Option"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-2 border-right"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Savings"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-2 border-right"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "You Pay Today"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-2 border-right"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Future Payments"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Total"
                                                                  ),
                                                                  _vm.checkoutPageName !==
                                                                  "nwidCheckout"
                                                                    ? [
                                                                        _vm._v(
                                                                          "\n                                Price"
                                                                        )
                                                                      ]
                                                                    : _vm._e()
                                                                ],
                                                                2
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row py-1 payment-item text-faint-gray no-gutters",
                                                        attrs: {
                                                          id: "pay-full-1"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col border-right smaller-font-content font-weight-bold text-black"
                                                          },
                                                          [
                                                            _c("form-block", {
                                                              staticClass:
                                                                "form-group",
                                                              attrs: {
                                                                formdata: item
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-2 border-right text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-green font-weight-bold"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currency-filter"
                                                                    )(
                                                                      item.savings
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-gray sm-txt"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Discount"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-2 border-right text-black text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "font-weight-bold"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currency-filter"
                                                                    )(
                                                                      item.downpayment
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.downpayment_subtext
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-gray sm-txt"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.downpayment_subtext
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-2 border-right text-center"
                                                          },
                                                          [
                                                            item.numpayments > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-gray sm-txt"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.numpayments
                                                                      ) +
                                                                        " Payments\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-faint-gray my-1"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "currency-filter"
                                                                      )(
                                                                        item.installment_amount
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.installment_amount_subtext
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-gray sm-txt"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.installment_amount_subtext
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-2 text-center"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-primary font-weight-bold text-qs-blue"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currency-filter"
                                                                    )(
                                                                      item.total_cost
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.total_cost_subtext
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-gray sm-txt"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.total_cost_subtext
                                                                      ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            item.bill_plan
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "cursorBox btn-sm btn-outline-primary d-inline-block smaller-font-content center mt-2",
                                                                    attrs: {
                                                                      type:
                                                                        "button"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.openBreakdownModal(
                                                                          "breakdownHeader-" +
                                                                            item
                                                                              .bill_plan
                                                                              .bill_plan_id
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Breakdown"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.bill_plan
                                                      ? _c(
                                                          "modal",
                                                          {
                                                            attrs: {
                                                              name:
                                                                "breakdownHeader-" +
                                                                item.bill_plan
                                                                  .bill_plan_id,
                                                              height: "auto",
                                                              scrollable: true,
                                                              focusTrap: "true"
                                                            },
                                                            on: {
                                                              opened: function(
                                                                $event
                                                              ) {
                                                                return _vm.modalOpened(
                                                                  "breakdownModal"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("Trap", [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "breakdown-modal-top pt-2 pl-3 pr-2 bg-primary text-white"
                                                                },
                                                                [
                                                                  _c(
                                                                    "h3",
                                                                    {
                                                                      staticClass:
                                                                        "breakdown-modal-header"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.label
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      ref:
                                                                        "breakdownModal",
                                                                      refInFor: true,
                                                                      staticClass:
                                                                        "cursorBox fa-stack uniform-icon-breakdown",
                                                                      attrs: {
                                                                        href:
                                                                          "JavaScript:void(0);",
                                                                        id:
                                                                          "breakdownModal",
                                                                        name:
                                                                          "breakdownModal"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.closeBreakdownModal(
                                                                            "breakdownHeader-" +
                                                                              item
                                                                                .bill_plan
                                                                                .bill_plan_id
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "fas fa-circle fa-stack-2x",
                                                                          staticStyle: {
                                                                            color:
                                                                              "#fff"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "fas fa-times fa-stack-1x",
                                                                          staticStyle: {
                                                                            color:
                                                                              "#1C3664"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("img", {
                                                              staticClass:
                                                                "carrier-logo pl-3 my-2",
                                                              attrs: {
                                                                src:
                                                                  item.bill_plan
                                                                    .logo_url
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "pl-3 pr-3 pb-3"
                                                              },
                                                              [
                                                                _c(
                                                                  "table",
                                                                  {
                                                                    staticClass:
                                                                      "table table-sm table-striped mb-0 w-100"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "thead",
                                                                      {
                                                                        staticClass:
                                                                          "blueWhiteHeaderFooter smaller-font-content bg-primary text-white"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "th",
                                                                              {
                                                                                attrs: {
                                                                                  scope:
                                                                                    "col"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Installment"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "th",
                                                                              {
                                                                                attrs: {
                                                                                  scope:
                                                                                    "col"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Date"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "th",
                                                                              {
                                                                                attrs: {
                                                                                  scope:
                                                                                    "col"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Amount"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "tbody",
                                                                      {
                                                                        staticClass:
                                                                          "breakdown-table-body"
                                                                      },
                                                                      _vm._l(
                                                                        item
                                                                          .bill_plan
                                                                          .bill_plan_installments,
                                                                        function(
                                                                          installment,
                                                                          installmentKey
                                                                        ) {
                                                                          return _c(
                                                                            "tr",
                                                                            {
                                                                              key: installmentKey
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "td",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      installment.installment_name
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "td",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      installment.installment_date
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "td",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      installment.amount
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "tfoot",
                                                                      {
                                                                        staticClass:
                                                                          "blueWhiteHeaderFooter bg-primary text-white"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "td"
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                staticStyle: {
                                                                                  "text-align":
                                                                                    "right"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Total:"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item
                                                                                      .bill_plan
                                                                                      .bill_plan_total
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.billingInformationSection
              ? _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "shadow-sm" },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            {
                              staticClass: "p-1",
                              attrs: { "header-tag": "header", role: "tab" }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.autoBillingInfo",
                                      modifiers: { autoBillingInfo: true }
                                    }
                                  ],
                                  attrs: { block: "", variant: "primary" }
                                },
                                [
                                  _c("span", { staticClass: "card-heading" }, [
                                    _c("span", {
                                      staticClass: "fas fa-car mr-1"
                                    }),
                                    _vm._v(
                                      "\n                    Billing Information\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "toggle-icon",
                                      attrs: { "data-v-87cda704": "" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "toggle-down fas fa-b-angle-down ",
                                        attrs: { "data-v-87cda704": "" }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "toggle-up fas fa-b-angle-up",
                                        attrs: { "data-v-87cda704": "" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "autoBillingInfo",
                                accordion: "autoBillingInfo",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _c("b-card-text", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row w-100 mx-0 no-gutters"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-6 pr-2"
                                          },
                                          [
                                            _vm.samePaymentOptionSelected
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "form-group",
                                                    attrs: {
                                                      id:
                                                        "QTE_SameHomeBillingInfo_block"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "position-relative"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "field-container ml-4 pr-2"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "field-input-checkbox"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "input-group d-block mr-1 mt-1"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm.QTE_SameHomeBillingInfo,
                                                                                expression:
                                                                                  "QTE_SameHomeBillingInfo"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "form-check-input mt-1",
                                                                            attrs: {
                                                                              type:
                                                                                "checkbox",
                                                                              "aria-describedby":
                                                                                "QTE_SameHomeBillingInfo_describedby",
                                                                              disabled:
                                                                                this
                                                                                  .$store
                                                                                  .getters
                                                                                  .getHomeBindStatus &&
                                                                                this
                                                                                  .$store
                                                                                  .getters
                                                                                  .getHomeBindStatus
                                                                                  .Status ===
                                                                                  "Success",
                                                                              id:
                                                                                "QTE_SameHomeBillingInfo",
                                                                              name:
                                                                                "QTE_SameHomeBillingInfo"
                                                                            },
                                                                            domProps: {
                                                                              checked: Array.isArray(
                                                                                _vm.QTE_SameHomeBillingInfo
                                                                              )
                                                                                ? _vm._i(
                                                                                    _vm.QTE_SameHomeBillingInfo,
                                                                                    null
                                                                                  ) >
                                                                                  -1
                                                                                : _vm.QTE_SameHomeBillingInfo
                                                                            },
                                                                            on: {
                                                                              change: [
                                                                                function(
                                                                                  $event
                                                                                ) {
                                                                                  var $$a =
                                                                                      _vm.QTE_SameHomeBillingInfo,
                                                                                    $$el =
                                                                                      $event.target,
                                                                                    $$c = $$el.checked
                                                                                      ? true
                                                                                      : false
                                                                                  if (
                                                                                    Array.isArray(
                                                                                      $$a
                                                                                    )
                                                                                  ) {
                                                                                    var $$v = null,
                                                                                      $$i = _vm._i(
                                                                                        $$a,
                                                                                        $$v
                                                                                      )
                                                                                    if (
                                                                                      $$el.checked
                                                                                    ) {
                                                                                      $$i <
                                                                                        0 &&
                                                                                        (_vm.QTE_SameHomeBillingInfo = $$a.concat(
                                                                                          [
                                                                                            $$v
                                                                                          ]
                                                                                        ))
                                                                                    } else {
                                                                                      $$i >
                                                                                        -1 &&
                                                                                        (_vm.QTE_SameHomeBillingInfo = $$a
                                                                                          .slice(
                                                                                            0,
                                                                                            $$i
                                                                                          )
                                                                                          .concat(
                                                                                            $$a.slice(
                                                                                              $$i +
                                                                                                1
                                                                                            )
                                                                                          ))
                                                                                    }
                                                                                  } else {
                                                                                    _vm.QTE_SameHomeBillingInfo = $$c
                                                                                  }
                                                                                },
                                                                                function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.selectSameHomeBillingInfoRadio()
                                                                                }
                                                                              ]
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "pr-2 field-info "
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "field-label w-100 align-top d-inline-flex"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "align-top",
                                                                        attrs: {
                                                                          for:
                                                                            "QTE_SameHomeBillingInfo"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Use the same Billing Information as " +
                                                                                _vm._s(
                                                                                  _vm.getFlow
                                                                                ) +
                                                                                " policy."
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.QTE_SameHomeBillingInfo
                                              ? _c(
                                                  "div",
                                                  [
                                                    _vm._l(
                                                      _vm.pageFieldsArray,
                                                      function(item, key) {
                                                        return [
                                                          item.section ==
                                                          "Billing Information"
                                                            ? _c(
                                                                "div",
                                                                { key: key },
                                                                [
                                                                  _vm.newHeader(
                                                                    key,
                                                                    _vm.pageFieldsArray,
                                                                    item.sub_section
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          key:
                                                                            key +
                                                                            "2",
                                                                          staticClass:
                                                                            "row mx-0 my-2 py-1 bg-ltblue text-white"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-12",
                                                                              attrs: {
                                                                                role:
                                                                                  "heading",
                                                                                "aria-level":
                                                                                  "4"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.sub_section
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "form-block",
                                                                    {
                                                                      key: key,
                                                                      staticClass:
                                                                        "form-group",
                                                                      attrs: {
                                                                        formdata: item,
                                                                        vgsStatus:
                                                                          _vm.vgsStatus
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-6 pl-2"
                                          },
                                          [
                                            _vm._l(
                                              _vm.carrierPaymentInformationSection,
                                              function(item, key) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      key: key,
                                                      staticClass:
                                                        "rounded-top",
                                                      class: {
                                                        "bg-green": !_vm.isBlue(
                                                          item.section
                                                        ),
                                                        "bg-primary": _vm.isBlue(
                                                          item.section
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "text-center text-white py-2 mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.section)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      key: key + "2",
                                                      staticClass:
                                                        "rounded-bottom border-thick pb-2 mb-3",
                                                      class: {
                                                        "border-green": !_vm.isBlue(
                                                          item.section
                                                        ),
                                                        "border-primary": _vm.isBlue(
                                                          item.section
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "final-rate mx-auto text-center text-primary font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                              " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency-filter"
                                                                )(
                                                                  item.payment_amount
                                                                )
                                                              ) +
                                                              "\n                            "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      item.section ===
                                                      "Monthly Payment"
                                                        ? _c("div", {
                                                            staticClass:
                                                              "text-center smaller-font-content",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                item.blurb
                                                              )
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center mx-auto my-3 w-100"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-warning my-0 py-2 w-100",
                                                attrs: { role: "note" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row no-gutters"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-inline-block pr-2 my-auto"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            width: "25px",
                                                            height: "25px",
                                                            src: require("../../../assets/exclamation-circle-yellow-new.svg"),
                                                            alt: "info"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col d-inline-block my-auto smaller-font-content"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "mb-0 text-dark-gray"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Confirm Payment Information:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              " Confirm the\n                                amounts of today’s payment and any future monthly payments with the customer."
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.checkoutSection
              ? _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "shadow-sm" },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            {
                              staticClass: "p-1",
                              attrs: { "header-tag": "header", role: "tab" }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.autoCheckoutSection",
                                      modifiers: { autoCheckoutSection: true }
                                    }
                                  ],
                                  attrs: { block: "", variant: "primary" }
                                },
                                [
                                  _c("span", { staticClass: "card-heading" }, [
                                    _c("span", {
                                      staticClass: "fas fa-car mr-1"
                                    }),
                                    _vm._v(
                                      "\n                    Billing Information\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "toggle-icon",
                                      attrs: { "data-v-87cda704": "" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "toggle-down fas fa-b-angle-down ",
                                        attrs: { "data-v-87cda704": "" }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "toggle-up fas fa-b-angle-up",
                                        attrs: { "data-v-87cda704": "" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "autoCheckoutSection",
                                accordion: "autoCheckoutSection",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _c("b-card-text", [
                                    _c(
                                      "div",
                                      { staticClass: "row w-100  mx-3" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-11 w-60 alert alert-primary  py-2  .mb-4",
                                            attrs: { role: "note" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row no-gutters" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-inline-block pr-2 my-auto"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        width: "20px",
                                                        height: "20px",
                                                        src: require("../../../assets/info-circle-blue.svg"),
                                                        alt: "info"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "col d-inline-block my-auto smaller-font-content",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.infoContent()
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.pdfLinkCov && _vm.pdfLinkCov[0]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex  mx-3 justify-content-center "
                                          },
                                          [
                                            _vm.pdfLinkCov &&
                                            _vm.pdfLinkCov.length > 1 &&
                                            _vm.pdfLinkCov[0]
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn mb-2 mr-3 btn-btn btn-outline-primary",
                                                    attrs: {
                                                      type: "button",
                                                      role: "button"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.redirectToCoverage(
                                                          _vm.pdfLinkCov[0]
                                                            .field_value
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pdfLinkCov[0].label
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.pdfLinkCov &&
                                            _vm.pdfLinkCov.length === 1 &&
                                            _vm.pdfLinkCov[0]
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn mb-2 btn-btn btn-primary",
                                                    attrs: {
                                                      type: "button",
                                                      role: "button"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.redirectToCoverage(
                                                          _vm.pdfLinkCov[0]
                                                            .field_value
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pdfLinkCov[0].label
                                                      ) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "fa fa-open-in-new ml-1"
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "16",
                                                              height: "16",
                                                              viewBox:
                                                                "0 0 16 16",
                                                              fill:
                                                                "currentColor"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d:
                                                                  "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                                                                fill:
                                                                  "currentColor"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.pdfLinkCov && _vm.pdfLinkCov[1]
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn mb-2 btn-btn btn-primary",
                                                    attrs: {
                                                      type: "button",
                                                      role: "button"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.redirectToCoverage(
                                                          _vm.pdfLinkCov[1]
                                                            .field_value
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pdfLinkCov[1].label
                                                      ) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "fa fa-open-in-new ml-1"
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "16",
                                                              height: "16",
                                                              viewBox:
                                                                "0 0 16 16",
                                                              fill:
                                                                "currentColor"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d:
                                                                  "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                                                                fill:
                                                                  "currentColor"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.autoAcknowledgementSection
              ? _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "shadow-sm" },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            {
                              staticClass: "p-1",
                              attrs: { "header-tag": "header", role: "tab" }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.autoAcknowledge",
                                      modifiers: { autoAcknowledge: true }
                                    }
                                  ],
                                  attrs: { block: "", variant: "primary" }
                                },
                                [
                                  _c("span", { staticClass: "card-heading" }, [
                                    _c("span", {
                                      staticClass: "fas fa-car mr-1"
                                    }),
                                    _vm._v(
                                      "\n                    Acknowledgements\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "toggle-icon",
                                      attrs: { "data-v-87cda704": "" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "toggle-down fas fa-b-angle-down ",
                                        attrs: { "data-v-87cda704": "" }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "toggle-up fas fa-b-angle-up",
                                        attrs: { "data-v-87cda704": "" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "autoAcknowledge",
                                accordion: "autoAcknowledge",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _vm._l(_vm.pageFieldsArray, function(
                                        item,
                                        qKey
                                      ) {
                                        return [
                                          item.section ===
                                            "Coverage Summary & Approval" &&
                                          item.field_type !== "label"
                                            ? _c(
                                                "div",
                                                { key: qKey },
                                                [
                                                  _c("form-block", {
                                                    staticClass: "form-group",
                                                    attrs: { formdata: item }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      }),
                                      _vm._v(" "),
                                      _vm.blurbs.formbottom &&
                                      _vm.blurbs.formbottom.visible
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center mx-auto mt-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "alert alert-primary my-0 py-2",
                                                  attrs: { role: "note" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row no-gutters"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-inline-block pr-2 my-auto"
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              width: "25px",
                                                              height: "25px",
                                                              src: require("../../../assets/info-circle-blue.svg"),
                                                              alt: "info"
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "smaller-font-content d-inline-block my-auto",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.blurbs
                                                              .formbottom
                                                              .content
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.covSumApproval &&
            _vm.pageData.fields &&
            _vm.pageData.fields.length > 0
              ? _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "shadow-sm" },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            {
                              staticClass: "p-1",
                              attrs: { "header-tag": "header", role: "tab" }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.autoCoverageSummary",
                                      modifiers: { autoCoverageSummary: true }
                                    }
                                  ],
                                  attrs: { block: "", variant: "primary" }
                                },
                                [
                                  _c("span", { staticClass: "card-heading" }, [
                                    _c("span", {
                                      staticClass: "fas fa-car mr-1"
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.colsArray[
                                            _vm.covSummarySectionArrayIndex
                                          ]
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "toggle-icon",
                                      attrs: { "data-v-87cda704": "" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "toggle-down fas fa-b-angle-down ",
                                        attrs: { "data-v-87cda704": "" }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "toggle-up fas fa-b-angle-up",
                                        attrs: { "data-v-87cda704": "" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "autoCoverageSummary",
                                accordion: "autoCoverageSummary",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _c("b-card-text", [
                                    _c(
                                      "div",
                                      { staticClass: "row mt-3 no-gutters" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 my-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center w-100"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "alert alert-warning my-0 py-2 w-100",
                                                    attrs: { role: "note" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row no-gutters"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-inline-block pr-2 my-auto"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                width: "25px",
                                                                height: "25px",
                                                                src: require("../../../assets/exclamation-circle-yellow-new.svg"),
                                                                alt: "info"
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col d-inline-block my-auto smaller-font-content"
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0 text-dark-gray"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    "Confirm Policy Details:"
                                                                  )
                                                                ]),
                                                                _vm._v(
                                                                  " Please confirm\n                                  the following policy details with the customer. Coverages that are not mentioned are\n                                  either not offered by the carrier or they were declined by the policyholder."
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.blurbs.formCoverageHelp &&
                                            _vm.blurbs.formCoverageHelp.visible
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-center w-100 mt-3"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "alert alert-primary my-0 py-2 w-100",
                                                        attrs: { role: "note" }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row no-gutters"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-inline-block pr-2 my-auto"
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    width:
                                                                      "25px",
                                                                    height:
                                                                      "25px",
                                                                    src: require("../../../assets/info-circle-blue.svg"),
                                                                    alt: "info"
                                                                  }
                                                                })
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("div", {
                                                              staticClass:
                                                                "col d-inline-block my-auto smaller-font-content",
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  _vm.blurbs
                                                                    .formCoverageHelp
                                                                    .content
                                                                )
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "mt-4 mb-3" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    height: "auto",
                                                    width: "150px",
                                                    src:
                                                      _vm.$store.getters
                                                        .getRc2LogoURL
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row mx-0 mb-1 smaller-font-content no-gutters"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 col-sm-3 font-weight-bold"
                                                  },
                                                  [_vm._v("Policy Start Date")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 col-sm-9"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getPolicyStartDate()
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input-link-button-list", {
                                              attrs: {
                                                pdfLinkCovData: _vm.pdfLinkCov
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "mt-3" },
                                              [
                                                _vm.polCov.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "py-1 pl-3 mb-2 text-dark-gray bg-gray",
                                                        attrs: {
                                                          role: "heading",
                                                          "aria-level": "4"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Liability Coverages"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(_vm.polCov, function(
                                                  pData,
                                                  pKey
                                                ) {
                                                  return [
                                                    pData.visible
                                                      ? _c(
                                                          "div",
                                                          {
                                                            key: pKey,
                                                            staticClass:
                                                              "row mx-0 mb-2 smaller-font-content"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    pData.label
                                                                  ) +
                                                                    "\n                              "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("div", {
                                                              staticClass:
                                                                "col-6 col-md-8 col-xl-6 text-dark-gray",
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  _vm.getAnswerOption(
                                                                    pData
                                                                  )
                                                                )
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }),
                                                _vm._v(" "),
                                                _vm.vehCov.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "py-1 pl-3 mt-3 text-dark-gray bg-gray",
                                                        attrs: {
                                                          role: "heading",
                                                          "aria-level": "4"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Vehicle Coverages"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "row mx-0" },
                                                  _vm._l(_vm.vehCov, function(
                                                    vData,
                                                    vKey
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: vKey,
                                                        staticClass:
                                                          "col-12 col-sm-6 mt-2",
                                                        attrs: {
                                                          id:
                                                            "sum-vehicle-" +
                                                            vKey
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "border rounded"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row mx-0 py-2 mb-2 bg-primary smaller-font-content text-white rounded-top"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-12",
                                                                    attrs: {
                                                                      "aria-level":
                                                                        "5"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        vData[0]
                                                                          .sub_index_section
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              vData,
                                                              function(
                                                                vehCovData,
                                                                covKey
                                                              ) {
                                                                return [
                                                                  vehCovData.visible
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          key: covKey,
                                                                          staticClass:
                                                                            "row mx-0 mb-2 smaller-font-content"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-12 font-weight-bold text-dark-gray"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  vehCovData.label
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-12",
                                                                              domProps: {
                                                                                innerHTML: _vm._s(
                                                                                  _vm.getAnswerOption(
                                                                                    vehCovData
                                                                                  )
                                                                                )
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            this.pageData.fields === null
              ? _c(
                  "div",
                  {
                    staticClass: "col-12",
                    attrs: { id: "error-next-step-container" }
                  },
                  [
                    _c("bundle-carrier-error", {
                      attrs: { errorData: _vm.autoBundleCarrierError }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dev-auto-fill", { attrs: { pageData: _vm.pageData } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2" }, [
      _c("i", { staticClass: "fa fa-icon-exclamation-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-12 pt-3 pb-2 mb-3 text-white text-left bg-danger",
        attrs: { "aria-level": "3" }
      },
      [
        _c("h1", [
          _c("i", { staticClass: "fa fa-icon-exclamation-circle" }),
          _vm._v(" We were unable to proceed due to an error.\n          ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-green rounded-top" }, [
      _c("h3", { staticClass: "text-center text-white py-2 mb-0" }, [
        _vm._v("Auto - Final Rate")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table-cell bg-driver-inc p-1" }, [
      _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
        _c("span", { staticClass: "fas fa-circle fa-stack-2x exclmn-icon-bg" }),
        _vm._v(" "),
        _c("span", {
          staticClass: "fas fa-exclamation exclmn-icon fa-stack-1x"
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "row mx-3 mt-2 py-1 smaller-font-content font-weight-bold bg-gray text-dark-gray"
      },
      [
        _c("div", { staticClass: "col border-right" }, [_vm._v("Driver Name")]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2 border-right" }, [_vm._v("Type")]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2 border-right" }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [_vm._v("Description")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35c55081", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c55081","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/AutoCheckout.vue
// module id = null
// module chunks = 